@if (tableEntries$ | async; as tableEntries) {
  <p-card class="p-card container">
    <p-contextMenu #cm [model]="contextMenuItems" />
    <p-table
      #salesTable
      [value]="tableEntries"
      [rows]="defaultRowsPerPage"
      [rowsPerPageOptions]="[50, 75, 100]"
      [paginator]="true"
      [globalFilterFields]="['agent', 'policyNumber', 'fullName', 'phone']"
      [filters]="{
        agent:
          agent?.role === userRole.ADVISOR
            ? {value: [agent?.firstName + ' ' + agent?.lastName], matchMode: 'contains'}
            : {},
      }"
      [(contextMenuSelection)]="selectedEntry"
      [contextMenu]="cm"
      [sortField]="'status.value'"
      [customSort]="true"
      [rowHover]="true"
      (sortFunction)="sortStatus($event)"
      selectionMode="single"
      dataKey="id"
      (onRowSelect)="onRowSelect($event)"
      paginatorDropdownScrollHeight="160px"
      styleClass="sales-table"
      responsiveLayout="scroll">
      <ng-template pTemplate="caption">
        <div class="table-section__header">
          <span i18n class="table-section__header--title">Liste des ventes</span>
          <span class="p-input-icon-left w-4">
            <i class="pi pi-search"></i>
            <input
              pInputText
              type="text"
              (input)="applyFilterGlobal($event)"
              i18n-placeholder
              placeholder="Chercher par conseiller, nº de police, nom ou téléphone" />
          </span>
        </div>
      </ng-template>

      <ng-template pTemplate="header">
        <tr class="table-section__thead">
          <th i18n
            >Conseiller
            <p-columnFilter
              field="agent"
              matchMode="contains"
              display="menu"
              [matchModeOptions]="matchModeOptions"
              [showOperator]="false"
              [showAddButton]="false"
              [showApplyButton]="false"
              i18n-placeholder
              placeholder="Chercher par conseiller">
              />
            </p-columnFilter>
          </th>
          <th i18n
            >Statut
            <p-columnFilter
              field="status.value"
              matchMode="in"
              display="menu"
              [showMatchModes]="false"
              [showOperator]="false"
              [showAddButton]="false"
              [showApplyButton]="false">
              <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                <p-multiSelect
                  [style]="{width: '300px'}"
                  [ngModel]="value"
                  [options]="proposalsStatusOptions | emTranslate"
                  i18n-placeholder
                  placeholder="Choisir"
                  (onChange)="filter($event.value)"
                  optionLabel="name"
                  optionValue="value"
                  i18n-emptyFilterMessage
                  emptyFilterMessage="Aucun résultat">
                </p-multiSelect>
              </ng-template>
            </p-columnFilter>
          </th>
          <th i18n>Nº de police </th>
          <th i18n>Nom complet </th>
          <th i18n>Téléphone </th>
          <th i18n>Produit(s) </th>
          <th i18n>Prime mensuelle </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-tableEntry>
        <tr
          [pSelectableRow]="tableEntry"
          [pContextMenuRow]="tableEntry"
          class="status"
          [attr.id]="'row-' + tableEntry.id">
          <td>{{ tableEntry.agent || '--' }}</td>
          <td>
            @if (tableEntry.status) {
              <p-tag
                [value]="tableEntry.status.text"
                [severity]="getStatusSeverity(tableEntry.status.value)" />
            }
          </td>
          <td>{{ tableEntry.policyNumber || '--' }}</td>
          <td>{{ tableEntry.fullName || '--' }}</td>
          <td>{{ tableEntry.phone | emPhone }}</td>
          <td>
            <div class="flex flex-wrap gap-1">
              @for (product of tableEntry.products; track product) {
                <span
                  class="product"
                  [ngClass]="{
                    'product--term': product.type === productType.TERM_LIFE,
                    'product--whole': product.type === productType.WHOLE_LIFE,
                    'product--rider': product.type === productType.RIDER,
                  }">
                  {{ product.name }}
                </span>
              }
            </div>
          </td>
          <td>{{ (tableEntry.monthlyPrice | currency: 'CAD' : 'symbol-narrow') || '--' }}</td>
        </tr>
      </ng-template>
    </p-table>
  </p-card>
} @else {
  <p-card class="p-card container">
    <p-table
      styleClass="sales-table"
      [paginator]="true"
      [value]="[' ', ' ', ' ', ' ', ' ', ' ']"
      [rows]="defaultRowsPerPage">
      <ng-template pTemplate="caption">
        <span i18n class="table-section__header--title">Liste des ventes</span>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th i18n>Conseiller</th>
          <th i18n>Statut</th>
          <th i18n>Nº de police</th>
          <th i18n>Nom complet</th>
          <th i18n>Téléphone</th>
          <th i18n>Produit(s)</th>
          <th i18n>Prime mensuelle</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body">
        <tr>
          @for (l of [].constructor(7); track l) {
            <td>
              <p-skeleton height="25px"></p-skeleton>
            </td>
          }
        </tr>
      </ng-template>
    </p-table>
  </p-card>
}
